/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers, withState } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { analytics } from 'services/Analytics'
import { USER_FORMS } from 'constants/forms'
import { formWithCaptcha } from 'hocs/formWithCaptcha'
import { withLocalization } from 'hocs/localization'
import { onForgotPassword } from 'redux-app/modules/auth'
import { onShowError } from 'redux-app/modules/alerts'
import { isCaptchaEnabled, isCaptchaWhiteListed } from 'redux-app/selectors/apiData'
import { getErrorCodes } from 'utils/error'
import ForgotPasswordForm from './ForgotPasswordForm'

export default compose(
  connect(
    state => ({
      isCaptchaEnabled: isCaptchaEnabled(state),
      isCaptchaWhiteListed: isCaptchaWhiteListed(state),
    }),
    {
      onForgotPassword,
      onShowError,
    },
  ),
  withState('isSent', 'onUpdateSend', false),
  withHandlers({
    onSubmit: ({ onForgotPassword, onUpdateSend, onShowError }) => formValues => {
      return onForgotPassword(formValues)
        .then(() => {
          onUpdateSend(true)
          analytics.forgotPassword()
        })
        .catch((error: any) => {
          analytics.showForgotPasswordError({ errorCodes: getErrorCodes(error) })
          onShowError(error, formValues)
          onUpdateSend(false)
        })
    },
  }),
  reduxForm({
    form: USER_FORMS.forgotPasswordForm,
  }),
  withLocalization('home.forgot'),
  formWithCaptcha,
)(ForgotPasswordForm)
